import { resolveDashboardPath } from './dashboardAccess';
import { NAV_GROUPS, type NavGroupDef } from './navConfig';
import { isNavRouteVisible } from './navAccess';
import type { PermissionCode, RoleCode } from './types';

export const DEFAULT_POST_AUTH_PATH = '/';
export const UNAUTHORIZED_LANDING_PATH = '/unauthorized';

export type AccessContext = {
  roleCode: RoleCode;
  permissions: ReadonlySet<PermissionCode>;
};

/**
 * Returns the first sidebar route the user may access, in nav order.
 * Uses the same ROUTE_ACCESS + canAccess policy as SideNav and route guards.
 */
export function getFirstAccessibleRoute(
  ctx: AccessContext,
  groups: NavGroupDef[] = NAV_GROUPS,
): string | null {
  for (const group of groups) {
    for (const item of group.items) {
      if (isNavRouteVisible(item.to, ctx)) {
        return item.to;
      }
    }
  }
  return null;
}

/** Landing target after auth, or unauthorized when no nav route is accessible. */
export function resolveLandingPath(ctx: AccessContext, groups?: NavGroupDef[]): string {
  const dashboardPath = resolveDashboardPath(ctx.permissions);
  if (dashboardPath) return dashboardPath;
  return getFirstAccessibleRoute(ctx, groups) ?? UNAUTHORIZED_LANDING_PATH;
}
